const localesKey = 'arirang:locales'

export const setLocales = async (locales: string): Promise<void> => {
	return localStorage.setItem(localesKey, locales)
}

export const getLocales = async (): Promise<string | null> => {
	return localStorage.getItem(localesKey)
}
